
import { CaseStudy } from "@/types/expertise";
import CaseStudyCard from "./CaseStudyCard";

interface CaseStudiesSectionProps {
  caseStudies: CaseStudy[];
}

const CaseStudiesSection = ({ caseStudies }: CaseStudiesSectionProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {caseStudies.map((study, index) => (
        <CaseStudyCard key={study.id} study={study} index={index} />
      ))}
    </div>
  );
};

export default CaseStudiesSection;
